import { Price as PriceModel } from 'models/Price';

export interface Page {
  page?:
    | 'productpageMobile'
    | 'productpage'
    | 'productlist'
    | 'switchProductlist'
    | 'topsellers'
    | 'accessories'
    | 'installation'
    | 'search'
    | 'addons'
    | 'productListHero'
    | 'addToCartPush';
}

interface Props extends Page {
  price: Partial<PriceModel>;
  isCampaign?: boolean;
  isLowPrice?: boolean;
  isLoweredPrice?: boolean;
}

export const getFormattedPrice = ({ page, isCampaign, isLoweredPrice, price }: Props) => {
  const { regularPrice = 0 } = price;
  const pages = [
    'productpage',
    'productpageMobile',
    'addons',
    'productlist',
    'switchProductlist',
    'accessories',
    'topsellers'
  ] as (typeof page)[];
  const isValidPage = pages.includes(page);
  const hasRegularPrice = regularPrice > 0;
  const isSpecialPrice = isCampaign || isLoweredPrice;

  if (isValidPage && hasRegularPrice && isSpecialPrice) {
    return {
      price: regularPrice
    };
  }

  return {
    price: 0
  };
};
